import { AxiosError } from 'axios';
import { GET_GSC_UPLOADED_FILE_INFO_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { GET_GSC_UPLOADED_FILE_INFO_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface UploadedFileModel {
  fileUuid: string;
  fileName: string;
  fileSizeInBytes: number;
  isSubmitted: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: UploadedFileModel[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetUploadedFileInfo = ({ uuid, onSuccess, onError }: Input) => {
  const getUploadedFileInfo = async () => {
    const res = await axiosClient.get<UploadedFileModel[]>(GET_GSC_UPLOADED_FILE_INFO_URL(uuid));
    return res.data;
  };

  return useCustomQuery(GET_GSC_UPLOADED_FILE_INFO_QUERY_KEY, getUploadedFileInfo, {
    onSuccess,
    onError,
  });
};
